import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import AOS from "aos";

import "aos/dist/aos.css";
import "./style.css";

const ContactUs = () => {
  const [lang, setLang] = useState("En");

  useEffect(() => {
    if (localStorage.getItem("language") === "En") {
      setLang("En");
    } else if (localStorage.getItem("language") === "Fr") {
      setLang("Fr");
    }
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);

  return (
    <div>
      <div class="bg-img">
        <div class="container">
          <div class="cover-title">
            {lang === "Fr" ? <h1>Contactez-nous</h1> : <h1>Contact us</h1>}
          </div>
        </div>
      </div>

      <section className="contact-us">
        <div
          className="contact-leftBox"
          data-aos="fade-down-right"
          data-aos-duration="1000"
        >
          {lang === "Fr" ? (
            <h3>Vision de gold bar</h3>
          ) : (
            <h3>Gold Bar Vision</h3>
          )}

          <img src={require("../../Assets/vision.jpg")} alt="" />
          {lang === "Fr" ? (
            <p>Gold Bar International LTD Vision, mission et valeurs </p>
          ) : (
            <p>Gold Bar International LTD Vision , Mission And Values </p>
          )}

          <Link to="/our-vision">
          {lang === "Fr" ? (
               <p className="button2">Lire la suite</p>
          ) : (
            <p className="button2">Read More</p>
          )}
         
          </Link>
        </div>
        <div
          className="ContactContent"
          data-aos="fade-down"
          data-aos-duration="1500"
        >
          {lang === "Fr" ? <h1>Contactez-nous</h1> : <h1>Contact us</h1>}
          {lang === "Fr" ? (
            <p class="text">
              Pour nous contacter par email, il vous suffit de remplir le
              formulaire ci-dessous
            </p>
          ) : (
            <p class="text">
              To contact us by email, simply fill in the form below.
            </p>
          )}

          <form id="contactform">
            <div class="form">
              <label>
                {lang === "Fr" ? <p>Nom & Prénom :</p> : <p>Name :</p>}
              </label>
              <input
                type="text"
                size="30"
                name="name"
                id="contactname"
                class="required"
              />
            </div>
            <div class="form">
              <label>
                <p>Email :</p>
              </label>
              <input
                type="text"
                size="30"
                name="email"
                id="email"
                class="required email"
              />
            </div>
            <div class="form">
              <label>
                {lang === "Fr" ? <p>Téléphone :</p> : <p>Mobile :</p>}
              </label>
              <input name="mobile" type="text" size="30" />
            </div>
            <div class="form">
              <label>
                <p>Message :</p>
              </label>
              <textarea
                rows="5"
                cols="30"
                name="message"
                id="message"
                class="required"
              ></textarea>
            </div>
            {lang === "Fr" ? (
              <button class="sub-btn btn-border btn-sm btn" type="submit">
                Envoyer
              </button>
            ) : (
              <button class="sub-btn btn-border btn-sm btn" type="submit">
                Submit
              </button>
            )}
          </form>
          <iframe
            className="map"
            width="100%"
            height="380"
            id="gmap_canvas"
            src="https://maps.google.com/maps?q=71-75%20Shelton%20Street,%20Covent%20Garden,%20London,%20WC2H%209JQ.%20&t=&z=13&ie=UTF8&iwloc=&output=embed"
            frameborder="0"
            scrolling="no"
            marginheight="0"
            marginwidth="0"
          ></iframe>
        </div>
        <div
          className="contact-rightBox"
          data-aos="fade-down-left"
          data-aos-duration="1000"
        >
          {lang === "Fr" ? <h2>Coordonnées</h2> : <h2>Contact Info</h2>}

          <img
            src="https://makah-madinah.vercel.app/static/media/company.c8dd00e27492b2551964.jpg"
            alt=""
            width="190px"
            height="107px"
          />

          <div className="contactInfo">
            {lang === "Fr" ? (
              <h6>
                <i class=" fa fa-home"></i> Siège Social
              </h6>
            ) : (
              <h6>
                <i class=" fa fa-home"></i> Head Office
              </h6>
            )}

            {lang === "Fr" ? (
              <p>
                71-75 Shelton Street Covent Garden, Londres, Royaume-Uni WC2H
                9JQ
              </p>
            ) : (
              <p>
                71-75 Shelton Street Covent Garden, London, United Kingdom WC2H
                9JQ
              </p>
            )}
            {lang === "Fr" ? (
              <p>Tél : +44 (020) 8168 0540</p>
            ) : (
              <p>Tel : +44 (020) 8168 0540</p>
            )}

            <h6>
              <i class=" fas fa-envelope "></i> EMAIL
            </h6>

            <p>info@goldbarint.com</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactUs;
